export const ANONYMOUS_CART_STORAGE_KEY = 'tq_public_purchase_cart:anonymous'
const LEGACY_CART_STORAGE_KEY = 'tq_public_purchase_cart'
const CUSTOMER_CART_OWNER_STORAGE_KEY = 'tq_customer_cart_owner'

function localStorageOrNull() {
  try {
    return globalThis.localStorage
  } catch {
    return null
  }
}

function sessionStorageOrNull() {
  try {
    return globalThis.sessionStorage
  } catch {
    return null
  }
}

export function getCustomerCartOwner() {
  return sessionStorageOrNull()?.getItem(CUSTOMER_CART_OWNER_STORAGE_KEY) || null
}

export function customerCartStorageKey(owner = getCustomerCartOwner()) {
  return owner ? `tq_public_purchase_cart:user:${encodeURIComponent(owner)}` : ANONYMOUS_CART_STORAGE_KEY
}

export function setCustomerCartOwner(owner: string | null) {
  const storage = sessionStorageOrNull()
  const local = localStorageOrNull()
  if (!storage || !local) return

  if (owner) {
    const anonymousKey = ANONYMOUS_CART_STORAGE_KEY
    const anonymousCart = local.getItem(anonymousKey) ?? local.getItem(LEGACY_CART_STORAGE_KEY)
    if (anonymousCart !== null) local.setItem(customerCartStorageKey(owner), anonymousCart)
    local.removeItem(anonymousKey)
    local.removeItem(LEGACY_CART_STORAGE_KEY)
    storage.setItem(CUSTOMER_CART_OWNER_STORAGE_KEY, owner)
    return
  }

  storage.removeItem(CUSTOMER_CART_OWNER_STORAGE_KEY)
}
